import { Component, input, output } from '@angular/core';
import { ButtonModule } from 'primeng/button';

/**
 * What the filing page shows in place of the sheet body when the
 * conversion-wide load failed with any class except PERM/RESP/AUTH.
 *
 * - **Retry flag off** (`RuntimeConfigService.filingLoadRetryEnabled`, every
 *   deployed environment today): a blank sheet area. The toast is the only
 *   message — repeating its sentence in the centre added nothing (P.O.,
 *   2026-10-06).
 * - **Retry flag on**: the toast's single-line summary plus a Retry button.
 *   The summary stays here because a retry that fails again inside the toast
 *   gate's window shows no new toast, so this is the only place the new code
 *   appears.
 *
 * Presentational only: the container owns what Retry does
 * (`FilingFormContainerComponent.retryLoad`).
 */
@Component({
  selector: 'app-filing-load-failure-panel',
  standalone: true,
  imports: [ButtonModule],
  template: `
    <div class="flex flex-col items-center justify-center gap-4 py-16 text-center"
         data-testid="filing-load-failure-panel">
      @if (retryEnabled()) {
        <p class="text-sm text-gray-700" role="status" aria-live="polite"
           data-testid="filing-load-failure-summary">{{ summary() }}</p>
        <p-button label="Retry" icon="pi pi-refresh" data-testid="filing-load-retry"
                  (onClick)="retry.emit()" />
      }
    </div>
  `,
})
export class FilingLoadFailurePanelComponent {
  readonly summary = input.required<string>();
  readonly retryEnabled = input<boolean>(false);
  readonly retry = output<void>();
}
